import EnvironmentConfiguration from "../../types/EnvironmentConfiguration";

/** The roster of currently available experiments for the application. */
enum ExperimentKey {
  /** A key solely for use in testing. */
  Testing = "For use in testing",
  /** A key for assigning patients to the single medical step treatment flow. */
  SingleMedicalStepFlow = EnvironmentConfiguration.convertDotCom.singleMedicalStepFlowExperimentKey
}

export default ExperimentKey;
